import { Component,  OnInit, ViewChild, Input } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { IAdministrativeComplaintView, IResponseLettersView, ISiteVisitModel } from 'app/models/mainMenu/mainMenu';
import { ComplaintService } from 'app/services/complaint/complaint.service';
import { MainMenuService } from 'app/services/mainMenu/mainMenu.service';

@Component({
  selector: 'app-mainMenu-siteVisit',
  templateUrl: './siteVisit.component.html',
  styleUrls: ['./siteVisit.component.scss']
})

export class SiteVisitComponent implements OnInit {
  @Input() countyId: string = '';
  siteVisitList: ISiteVisitModel[] = [];

  displayedColumns: string[] = ['complaintId', 'businessName', 'origComplaintDate', 'address', 'city', 'zipCode'];
  dataSource = new MatTableDataSource<ISiteVisitModel>(this.siteVisitList);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public mainMenu: MainMenuService,
    public complaintService: ComplaintService,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    // Site Visit
    this.mainMenu.getSiteVisits(this.countyId).subscribe({
      next: response => {
        this.mainMenu.siteVisitList = response;
        this.dataSource.data = this.mainMenu.siteVisitList;
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;      },
      error: e => {
        this.sharedService.toastr.error("Could not get Site Visits");
      },
    });    

  }

  rowClick(row: any) {
  }

  gotoComplaint(compId: string) {
    this.complaintService.complaintId = +compId;
    this.complaintService.complaintTab = 4;
    this.complaintService.complaintVisitTab = 0;
    this.sharedService.doRedirect('complaint/complaint/'+compId);
  }

}
